import { api } from './api';
import store from '@/store';
import WorkStock from '@/resources/constants/work-stock';

const setIsLoading = function (type, value) {
  store.commit(WorkStock.Mutations.IsLoading.SET, {
    type: type,
    value: value
  });
};

export default {
  LoadAll () {
    const endpoint = encodeURI(
      WorkStock.Endpoints.LoadAll());

    setIsLoading('LOAD_ALL', true);
    return api.get(endpoint)
      .finally(() => setIsLoading('LOAD_ALL', false));
  },

  StartReview (workStockItem) {
    const endpoint = encodeURI(
      WorkStock.Endpoints.StartReview(workStockItem.id));

    setIsLoading('START_REVIEW', true);
    return api.put(endpoint)
      .finally(() => setIsLoading('START_REVIEW', false));
  },

  EndReview (workStockItem) {
    const endpoint = encodeURI(
      WorkStock.Endpoints.EndReview(workStockItem.id));

    setIsLoading('END_REVIEW', true);
    return api.put(endpoint)
      .finally(() => setIsLoading('END_REVIEW', false));
  },

  Accept (data) {
    const endpoint = encodeURI(
      WorkStock.Endpoints.Accept(data.item.id));

    setIsLoading('ACCEPT', true);
    return api.put(endpoint, { value: data.comment })
      .finally(() => setIsLoading('ACCEPT', false));
  },

  Reject (data) {
    const endpoint = encodeURI(
      WorkStock.Endpoints.Reject(data.item.id));

    setIsLoading('REJECT', true);
    return api.put(endpoint, { value: data.comment })
      .finally(() => setIsLoading('REJECT', false));
  }
};
